import { createStyles, makeStyles, Theme } from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForwardIos";
import { DiagramEngine, PortWidget } from "@projectstorm/react-diagrams-core";
import { observer } from "mobx-react-lite";
import React from "react";
import { OutputType } from "../../treeBlockOutputsDataSource";
import { TreeBlockType } from "../../TreeBlockType";
import { AdvancedPortModel } from "../AdvancedLinkModel";
import { DefaultTreeBlockModel } from "../DefaultTreeBlockModel";
import { OutputLabel } from "../OutputLabel";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    portsWrapper: {
      display: "flex",
      justifyContent: "space-between",
      flex: "1 1 auto"
    },
    portsContainer: {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      ":first-of-type": {
        marginRight: "10px"
      },
      ":only-child": {
        marginRight: "0px"
      }
    },
    portInContainer: {
      display: "flex"
    },
    portOutContainer: {
      display: "flex",
      justifyContent: "flex-end"
    },
    portName: {
      display: "flex",
      alignItems: "center",
      padding: "3px"
    },
    port: {
      display: "flex",
      padding: "3px",
      alignItems: "center",
      "&:hover": {
        background: "rgb(192, 255, 0)"
      }
    }
  })
);

export interface PortsWrapperProps {
  node: DefaultTreeBlockModel;
  engine: DiagramEngine;
}

export const PortsWrapper = observer((props: PortsWrapperProps) => {
  const classes = useStyles();
  const { node, engine } = props;

  const defaultOutPort = node.getOutPort("DEFAULT");

  return (
    <div className={classes.portsWrapper}>
      <div className={classes.portsContainer}>
        {node.getPort("IN") && <PortIn node={node} engine={engine} />}
      </div>
      <div className={classes.portsContainer}>
        {node
          .getOutPorts()
          .map(
            (port: AdvancedPortModel, key: number) =>
              port.getOutputType() !== OutputType.DEFAULT && (
                <PortOut
                  key={key}
                  port={port}
                  engine={engine}
                  treeBlockType={node.name as TreeBlockType}
                />
              )
          )}
        {defaultOutPort && (
          <PortOut
            port={defaultOutPort}
            engine={engine}
            treeBlockType={node.name as TreeBlockType}
          />
        )}
      </div>
    </div>
  );
});

interface InPortProps {
  node: DefaultTreeBlockModel;
  engine: DiagramEngine;
}

const PortIn = (props: InPortProps) => {
  const classes = useStyles();
  const { node, engine } = props;

  return (
    <div className={classes.portInContainer}>
      <PortWidget
        className={classes.port}
        engine={engine}
        //@ts-ignore
        port={node.getPort("IN")}
      >
        <ArrowForwardIcon fontSize={"inherit"} />
      </PortWidget>
      <div className={classes.portName}>{node!.getPort("IN")!.getName()}</div>
    </div>
  );
};

interface OutPortProps {
  port: AdvancedPortModel;
  engine: DiagramEngine;
  treeBlockType: TreeBlockType;
}

const PortOut = (props: OutPortProps) => {
  const classes = useStyles();
  const { port, engine, treeBlockType } = props;

  return (
    <div className={classes.portOutContainer}>
      <OutputLabel
        value={port?.getName()}
        label={port && port.serialize().label}
        treeBlockType={treeBlockType}
        outputType={port.getOutputType()}
      />
      <PortWidget className={classes.port} engine={engine} port={port}>
        <ArrowForwardIcon fontSize={"inherit"} />
      </PortWidget>
    </div>
  );
};
